import { localStorageManager } from './LocalStorageManager'

export const clearLocalStorage = () => {
    localStorageManager.remove('TRANSMISSIONS_FETCH_LIMIT_LOCALSTORAGE_KEY')
}
